exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".update-notification[data-v-e7f3287c]{position:fixed;top:20px;right:20px;z-index:9999;max-width:400px;box-shadow:0 4px 12px rgba(0,0,0,.15);border-radius:8px}.update-alert[data-v-e7f3287c]{border:none;border-radius:8px;margin-bottom:0}.update-alert .alert-dismissible .close[data-v-e7f3287c]{padding:.75rem 1rem}.gap-2[data-v-e7f3287c]{gap:.5rem}@media (max-width:768px){.update-notification[data-v-e7f3287c]{top:10px;right:10px;left:10px;max-width:none}}", ""]);

// exports
